import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store';
import Dashboard from '../views/Dashboard.vue'
import Login from '../views/Auth/Login.vue'
import Recuperar from '../views/Auth/Recuperar.vue'
import Confirmacion from '../views/Auth/Confirmacion.vue'
import ConfAlta from '../views/Auth/confirmacionAlta.vue'
import RegistroProveedor from '../views/Auth/RegistroProveedor.vue'
import Home from '../views/Home.vue'
import OCDocPendiente from '../views/OCDocPendiente.vue'
import InvitacionProveedores from '../views/InvitacionProveedores.vue'
import EnvioFacturas from '../views/EnvioFacturas.vue'
import CuentaBancaria from '../views/CambioCuentaBancaria.vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(VueRouter)
Vue.use(require('vue-cookies'))

const routes = [
  {
    path: '*',
    name: 'Login',
    component: Login
  }, 
  {
    path: '/',
    name: 'Log',
    component: Login
  }, 
  {
    path: '/login',
    name: 'log',
    component: Login
  }, 
  {
    path: '/recuperar',
    name: 'Recuperar',
    component: Recuperar
  },
  {
    path: '/RegistroProveedor/:token',
    name: 'RegistroProveedor',
    component: RegistroProveedor
  },
  {
    path: '/confAlta:ms',
    name: 'ConfAlta',
    component: ConfAlta
  },
  {
    path: '/confirmacion/:token',
    name: 'Confirmacion',
    component: Confirmacion
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard, 
    meta: {requiresAuth: true},
    children: [
      {
        path: '/home',
        name: 'Home',
        component: Home      
      },
      /*{
        path: '/EnvioFacturas',
        name: 'Envio De Facturas',
        component: EnvioFacturas
      },*/
      {
        path: '/EnvioFacturas',
        name: 'EnvioDeFacturas',
        component: EnvioFacturas,
        props: { Id_OrdenCompra: true }
      },
      {
        path: '/OCDocPendiente',
        name: 'OCDocumentacionPendiente',
        component: OCDocPendiente,
        props: { message: true }
      },
      {
        path: '/InvitacionProveedores',
        name: 'InvitacionProveedores',
        component: InvitacionProveedores
      },
      {
        path: '/CuentaBancaria',
        name: 'CuentaBancaria',
        component: CuentaBancaria
      }
    ]
  }
]
console.log("este es la base" + process.env.BASE_URL)
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
      next('/login')    
   
  } else {
    next()
  }
})

export default router
